<template>
    <div v-if="!isLoadingC" class="pl-lg-4">
        <div v-if="!shortform"  class="row">
            <div v-if="!isService" class="col-lg-4">
                <label class="form-control-label">
                    Benutzerrolle
                    <span>*</span></label>
                <select multiple size="4" v-model="user.roles"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <!-- <option value="" disabled selected>Kunde</option> -->
                    <option v-if="isAdmin" value="ROLE_ADMIN">SuperAdmin</option>
                    <option value="ROLE_OPERATOR">Admin</option>
                    <option value="ROLE_SERVICE" selected>Service</option>
                    <option value="ROLE_USER">Keine Berechtigungen</option>
                </select>
            </div>
            <div v-if="isAdmin" class="col-lg-4">
                <label class="form-control-label">
                Derzeitige Organisation
                <span>*</span></label>
                <select v-model="user.customer"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <!-- <option value="" disabled selected>Kunde</option> -->
                    <option v-for="customer in customers" :key="customer.id" :value="customer['@id']">{{ customer.name }}
                    </option>
                </select>
            </div>
            <div v-if="user.customer !== null && !isService" class="col-lg-4">
                <label class="form-control-label">
                    Standort
                    <span>*</span></label>
                <select v-model="user.location"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg"
                        :class="[locCheck ? 'is-invalid' : '']">
                    <option :value="null">-</option>
                    <option v-for="location in locations" :key="location.id" :value="location['@id']">{{ location.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1">
                <base-radio class="col-form-label col-form-label-lg mb-3"
                            input-classes="form-control-alternative form-control-lg"
                            name="Herr"
                            v-model="user.title">
                    Herr
                </base-radio>
            </div>
            <div class="col-lg-1">
                <base-radio class="col-form-label col-form-label-lg mb-3"
                            input-classes="form-control-alternative form-control-lg"
                            name="Frau"
                            v-model="user.title">
                    Frau
                </base-radio>
            </div>
            <div class="col-lg-1">
                <base-radio class="col-form-label col-form-label-lg mb-3"
                            input-classes="form-control-alternative form-control-lg"
                            name="Divers"
                            v-model="user.title">
                    Divers
                </base-radio>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <base-input alternative=""
                            required
                            label="Vorname"
                            placeholder="Max"
                            input-classes="form-control-alternative"
                            v-model="user.firstname"
                />
            </div>
            <div class="col-lg-6">
                <base-input alternative=""
                            required
                            label="Nachname"
                            placeholder="Mustermann"
                            input-classes="form-control-alternative"
                            v-model="user.lastname"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <base-input alternative=""
                            required
                            label="E-Mail"
                            placeholder="mustermann@mustermail.de"
                            input-classes="form-control-alternative"
                            v-model="user.email"
                />
            </div>
            <div class="col-lg-6">
                <base-input alternative=""
                            required
                            label="Passwort"
                            placeholder="Passwort"
                            input-classes="form-control-alternative"
                            :valid="validPassword(user.plainPassword)"
                            v-model="user.plainPassword"
                />
                <base-button type="secondary" size="sm" v-on:click="generatePassword">Passwort generieren</base-button>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="form-control-label">
                    Wie oft soll über einer Nachrichten per E-Mail informiert werden?
                    <span>*</span></label>
                <select v-model="user.notificationStatus"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option value="daily">Täglich</option>
                    <option value="weekly">Wöchentlich</option>
                    <option value="monthly">Monatlich</option>
                    <option value="none">Keine Benachrichtigung</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <label class="form-control-label">
                    Positionen/Aufgabenfelder
                </label>
                <b-form-tags v-model="user.position" size="lg" add-on-change no-outer-focus class="mb-2">
                    <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
                        <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                            <li v-for="tag in tags" :key="tag" class="list-inline-item">
                                <b-form-tag
                                        @remove="removeTag(tag)"
                                        :title="tag"
                                        :disabled="disabled"
                                        variant="info"
                                >{{ tag }}</b-form-tag>
                            </li>
                        </ul>
                        <b-form-select
                                v-bind="inputAttrs"
                                v-on="inputHandlers"
                                :disabled="disabled || availableOptions.length === 0"
                                :options="availableOptions"
                        >
                            <template v-slot:first>
                                <!-- This is required to prevent bugs with Safari -->
                                <option disabled value="">Wählen Sie eine oder mehrere Aufgaben/Positionen</option>
                            </template>
                        </b-form-select>
                    </template>
                </b-form-tags>
                <label class="form-control-label mt-4">
                    Notizen
                </label>
                <textarea v-model="user.comment" class="form-control form-control-alternative" id="userComment" rows="3" placeholder="Hier ist Platz für Ihre Notizen"></textarea>
            </div>
        </div>
    </div>
    <div v-else><i class="fas fa-circle-notch fa-spin"></i> Loading Userform....</div>
</template>
<script>
    import { BFormTags } from 'bootstrap-vue'

    export default {
        name: 'userform',
        components: {'b-form-tags': BFormTags},
        props: {
          shortform: {
              type: Boolean,
              default: false
          },
            loadingProp: {
              type: Boolean,
                default: false
            }
        },
        data(){
            return {
                options: ['Geschäftsführer(in)', 'Inhaber(in)', 'Spielerschutzbeauftragte(r)', 'Sozialkonzeptbeauftragte(r)', 'Schulungsbeauftragte(r)', 'Aufsteller(in)'],
                user: {
                    location: null,
                    email: "",
                    plainPassword: "",
                    firstname: '',
                    lastname: "",
                    customer: null,
                    title: "Divers",
                    position: [],
                    roles: ['ROLE_SERVICE'],
                    comment: '',
                    notificationStatus: 'daily'
                },
                isLoading: false,
                tick: 1
            }
        },
        created(){
            if (!this.$store.getters['customer/isReady']) {
                this.isLoading = true;
                this.$store.dispatch('customer/getCustomerCollection').then(() => {
                        this.user.customer = '/api/customers/'+this.$store.getters['authentication/customer'];
                        this.isLoading = false;
                    }
                );
            } else {
                this.user.customer = '/api/customers/'+this.$store.getters['authentication/customer'];
            }
            if (this.shortform) this.user.lastname = 'Service';
            this.tick++;
        },
        computed: {
            customers() {
                return this.$store.getters['customer/showCustomerCollection'];
            },
            customerData() {
                return (this.$store.getters['customer/isReady'] && this.user.customer !== null) ? this.$store.getters['customer/showCustomerByIRI'](this.user.customer) : null;
            },
            locations() {
                return (this.$store.getters['customer/isReady'] && this.user.customer !== null) ? this.$store.getters['customer/showCustomerByIRI'](this.user.customer).locations : null;
            },
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            isService() {
                return this.$store.getters['authentication/isService'];
            },
            isLoadingC() {
                return this.isLoading || this.loadingProp;
            },
            availableOptions() {
                return this.options.filter(opt => this.user.position.indexOf(opt) === -1)
            },
            locCheck() {
                return this.user.location === null && this.user.roles.includes('ROLE_SERVICE');
            }
        },
        methods: {
            randomStr(len, arr) {
                var ans = '';
                for (var i = len; i > 0; i--) {
                    ans +=
                        arr[Math.floor(Math.random() * arr.length)];
                }
                return ans;
            },
            generatePassword() {
                this.user.plainPassword = this.randomStr(8,'12345678abcdefghijklmnopqrstuvwxyz!$%#?=&');
            },
            missingLocationCheck() {
                return this.user.location === null && this.user.roles.includes('ROLE_SERVICE')
            }
        }
    }
</script>